var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "animated-spinner-container",
      style: { backgroundImage: "url(" + _vm.eventSettings.backgroundUrl + ")" }
    },
    [
      _c("div", { staticClass: "spin-action" }, [
        _c(
          "h2",
          {
            staticClass: "prize-name",
            style: { opacity: _vm.visibility.prize_name !== "0" ? 1 : 0 }
          },
          [_vm._v(_vm._s(this.prizeInfo.name))]
        ),
        _vm._v(" "),
        _c(
          "h4",
          {
            staticClass: "winner-indicator",
            style: { opacity: _vm.visibility.winner_pos !== "0" ? 1 : 0 }
          },
          [
            _vm._v(
              "\n      Winner " +
                _vm._s(_vm.current_winner) +
                "\n      of " +
                _vm._s(_vm.total_winners) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "animated-spinner" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm._m(3),
          _vm._v(" "),
          _c("div", { staticClass: "text-container" }, [
            _vm.state == "spin"
              ? _c("div", { staticClass: "dummy transparent" }, [
                  _vm._v("0000000000")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.state == "spinning"
              ? _c("div", { staticClass: "dummy" }, [_vm._v("0000000000")])
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state == "result",
                  expression: "state=='result'"
                }
              ],
              staticClass: "animated-text"
            })
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.visibility.spin_btns !== "0",
                expression: "visibility.spin_btns !== '0'"
              }
            ],
            class: _vm.actionBtnClass
          },
          [
            this.state == "result"
              ? _c(
                  "button",
                  {
                    class: _vm.buttonDefault,
                    style: { color: _vm.btn_default_color },
                    on: {
                      click: function($event) {
                        return _vm.toggleRejectMenu()
                      }
                    }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.secondary_action))]),
                    _vm._v(" "),
                    this.state == "result" && this.showRejectMenu
                      ? _c("div", { staticClass: "reject-options" }, [
                          _c(
                            "button",
                            {
                              staticClass: "dropdown-item respin",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.performSecondaryAction("respin")
                                }
                              }
                            },
                            [_vm._v("Reject and respin")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "dropdown-item move-on",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.performSecondaryAction("moveon")
                                }
                              }
                            },
                            [_vm._v("Reject and move on")]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              : _c(
                  "button",
                  {
                    class: _vm.buttonDefault,
                    style: { color: _vm.btn_default_color },
                    on: {
                      click: function($event) {
                        return _vm.performSecondaryAction("skip")
                      }
                    }
                  },
                  [
                    _c("FullLoader", { attrs: { loading: _vm.createLoading } }),
                    _vm._v(
                      "\n        " + _vm._s(_vm.secondary_action) + "\n      "
                    )
                  ],
                  1
                ),
            _vm._v(" "),
            _c(
              "button",
              {
                class: _vm.buttonPrimary,
                style: { color: _vm.btn_primary_color },
                attrs: { disabled: _vm.disabled_confirm_button },
                on: {
                  click: function($event) {
                    return _vm.performPrimaryAction()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.primary_action))]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "finishModal", role: "dialog" }
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-body" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("p", { staticClass: "cancel-warning" }, [
                  _vm._v(
                    "\n            There are no more attendees on whom to perform the draw. You can either finish this draw\n            (all remaining winners will be blank) or cancel the draw (all previous winners info will be discarded).\n          "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-btn-container" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default spin",
                      on: {
                        click: function($event) {
                          return _vm.cancelDraw()
                        }
                      }
                    },
                    [_vm._v("Cancel the draw")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.finishDraw()
                        }
                      }
                    },
                    [_vm._v("Finish the draw")]
                  )
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm._m(5)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lights horizontal top" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/lights_horizontal.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lights horizontal bottom" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/lights_horizontal.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lights vertical left" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/lights_vertical.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lights vertical right" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/lights_vertical.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("Attention!")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("audio", { attrs: { id: "myAudio" } }, [
      _c("source", {
        attrs: {
          src: require("@/assets/sounds/spinning.mp3"),
          type: "audio/mpeg"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-507c5396", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-507c5396","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnimatedSpin.vue
// module id = null
// module chunks = 